import Loadable from "@loadable/component";

const SendUsEmailPage = Loadable(
  () => import(/* webpackChunkName: "send_us_email_page" */ "./sendUsEmail")
);

export default SendUsEmailPage;
